import { Injectable } from '@angular/core';
import { getOrderId } from '@features/order-ui/utils/order.utils';
import { PointsTransactionModel } from '@rd/types/points-transaction.model';
import { PointsTransaction } from '@rd/types/points-transaction.type';
import { PointsTransferShowResponse } from '@rd/types/points-transfer.response';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DateService } from '../date/date.service';
import { NydusNetworkApiDataService } from '../nydus-network-api-data/nydus-network-api-data.service';

// TransferConnect module uses V1, TransferConnectV2 uses V2
interface PointsTransferV1Params {
  firstName: string;
  lastName: string;
  loyaltyProgramId: string;
  transferAmount: number;
  number: string; // membership number
}

interface PointsTransferV2Params {
  loyaltyProgramId: string;
  membershipId: string;
  transferAmount: number;
}

interface PointsTransferPostParams {
  promoCode?: {
    code: string;
  };
  pointsTransfer: PointsTransferV1Params | PointsTransferV2Params;
}

@Injectable({
  providedIn: 'root',
})
export class PointsTransferApiService {
  constructor(
    private nydusNetworkApiDataService: NydusNetworkApiDataService,
    private dateService: DateService,
  ) {}

  postPointsTransfer(
    pointsTransferParams: PointsTransferPostParams,
  ): Observable<PointsTransaction> {
    return this.nydusNetworkApiDataService
      .post<PointsTransferShowResponse>('points_transfers', {
        ...pointsTransferParams,
      })
      .pipe(
        map((pointsTransferResponse) => {
          return this.transformPointsTransferShowResponse(
            pointsTransferResponse,
          );
        }),
      );
  }

  private transformPointsTransferShowResponse(
    pointsTransferResponse: PointsTransferShowResponse,
  ): PointsTransaction {
    const { data } = pointsTransferResponse;
    return this.transformPointsTransactionModel(data);
  }

  private transformPointsTransactionModel(
    pointsTransactionModel: PointsTransactionModel,
  ): PointsTransaction {
    const { id, attributes, relationships } = pointsTransactionModel;
    const {
      amount,
      balanceAsOf,
      category,
      description,
      status,
      orderFulfillmentStatus,
      productType,
      createdAt,
      transactionTime,
      metadata,
      orderItemData,
      entryType,
    } = attributes;

    const orderId = getOrderId(relationships);

    const transformedPointsTransaction = {
      id,
      amount,
      category,
      productType,
      status,
      orderFulfillmentStatus,
      balance: balanceAsOf,
      createdAt: this.dateService.parseDate(createdAt),
      transactionTime: this.dateService.parseDate(transactionTime),
      descriptor: description,
      metadata,
      orderItemData,
      entryType,
      orderId,
    };

    return transformedPointsTransaction;
  }
}
